import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

export interface TrackingRecentRow {
	id: number;
	event_name: string;
	created_at: string;
	created_by_id: string | null;
	entity_id: string | null;
	os: string | null;
	os_version: string | null;
	device_type: string | null;
	device_name: string | null;
	app_version: string | null;
	session_id: string | null;
	properties: unknown;
}

export interface RecentArgs {
	event?: string;
	limit?: number;
	userId?: string;
	refetchInterval?: number;
}

const fetchRecent = async (args: RecentArgs): Promise<TrackingRecentRow[]> => {
	const url = args.userId
		? `/tracking/users/${encodeURIComponent(args.userId)}/recent/`
		: "/tracking/recent/";
	const { data } = await cmsClient.get<TrackingRecentRow[]>(url, {
		params: {
			...(args.event ? { event: args.event } : {}),
			...(args.limit ? { limit: args.limit } : {})
		}
	});
	return data;
};

const useTrackingRecent = (args: RecentArgs) =>
	useQuery(
		[
			"tracking",
			"recent",
			args.userId ?? "all",
			args.event ?? "all",
			String(args.limit ?? 50)
		],
		() => fetchRecent(args),
		{ refetchInterval: args.refetchInterval }
	);

export default useTrackingRecent;
